import React from "react";

import * as S from "./styles";

export const Signature: React.FC = () => {
  return (
    <S.Container>
      <S.Logo />® is a platform at Gera Sinergia® company
    </S.Container>
  );
};
